module.exports = __webpack_public_path__ + "img/states-icon.5ef991b3.jpg";